import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { apiMain } from "services";
import { useQuery } from "hooks/useQuery";
import { routes } from "routes";
import "components/buttons/BaseButton/BaseButton.scss";

import "./MigrateImgurPage.scss";

export const MigrateImgurConfirmPage = (): JSX.Element => {
  const query = useQuery();

  const [error, setError] = useState<string|null>(null);
  const [code] = useState<string|null>(query.get("code"));

  useEffect(() => {
    if (code === null) {
      setError("Authorizatoin failed.  Please try again.");
    } else {
      apiMain.verifyImgurCode({ code }).then(() => {
        window.location.href = routes.migrateImgurSuccess();
      }).catch((e: any) => {
        const message = e.response?.data?.error?.message
          || "Error processing your request, please try again.";
        setError(message);
      });
    }
  }, [code]);

  const state = (() => {
    if (query.get("error") === "access_denied") {
      return "denied";
    }

    if (error) {
      return "error";
    }

    return "processing";
  })();

  document.title = "Migrate from Imgur";

  return (
    <div className="migratePage narrow page">
      <h1>Transfer your content from Imgur</h1>

      {state === "error" && (<>
        <p>Sorry, there was an error talking to Imgur.  Please try again later.</p>
        <Link className="BaseButton BaseButton_isPrimary" to={routes.migrateImgur()}>Try again</Link>
      </>)}

      {state === "denied" && (<>
        <p>Imgur reports that you denied us access to your account.&nbsp;
        This means we cannot continue transfering your Imgur uploads to RedGIFs.&nbsp;
        If you ever reconsider, you can <Link to={routes.migrateImgur()}>start this process again</Link>.</p>
      </>)}

      {!error && (
        <p>Please wait, processing your request...</p>
      )}
    </div>
  );
};
